<script lang="ts">
	import type { CmsLanguageRecord } from '$lib/data/types';
	import { locale } from 'svelte-i18n';
	import { normalizeLocale, validLocales } from '$lib/i18n';
	import { page } from '$app/stores';

	export let languages: CmsLanguageRecord[] = [];

	let selectedLanguage: CmsLanguageRecord;
	$: selectedLanguage =
		languages.find((lang) => normalizeLocale(lang.code) === $locale) || languages[0];

	let show = false;

	export const switchUrlLocale = (url: string, locale: string | null | undefined): string => {
		const segments = url.split('/');
		if (segments.length > 1 && validLocales.includes(segments[1])) {
			segments[1] = normalizeLocale(locale);
		}
		return segments.join('/');
	};

	export const switchLocale = (locale: string): void => {
		$locale = normalizeLocale(locale);
	};
</script>

<li class="nav-item nav-item--lang dropdown" on:mouseleave={() => (show = false)}>
	<!-- svelte-ignore a11y-invalid-attribute -->
	<a
		href="#"
		class="nav-link dropdown-toggle"
		role="button"
		aria-expanded={show}
		on:click|preventDefault={() => (show = !show)}
	>
		<img
			src="/img/locales/{normalizeLocale(selectedLanguage.code)}.svg"
			width="22"
			height="17"
			alt={selectedLanguage.name}
			loading="lazy"
		/>
	</a>

	<ul class="dropdown-menu" class:show>
		{#each languages as lang}
			{@const newLocale = lang.code.split('-')[0]}
			<li>
				<a
					class="dropdown-item"
					href={switchUrlLocale($page.url.pathname, newLocale)}
					data-sveltekit-preload-data="off"
					on:click={() => (show = false)}
				>
					<img
						src="/img/locales/{newLocale}.svg"
						width="22"
						height="17"
						alt={lang.name}
						loading="lazy"
					/>
				</a>
			</li>
		{/each}
	</ul>
</li>
